/**
 * The field — a single line on the page, raised and quiet until touched.
 * A thin wrapper over the `.field` component class in global.css (no new
 * CSS): it applies the class and forwards every native <input> prop, so
 * callers keep `type`, `value`, `onChange`, `placeholder`, refs, etc.
 */
import { forwardRef } from "react";
import type { InputHTMLAttributes } from "react";

export type FieldProps = InputHTMLAttributes<HTMLInputElement>;

export const Field = forwardRef<HTMLInputElement, FieldProps>(function Field(
  { className, ...rest },
  ref,
) {
  const classes = className ? `field ${className}` : "field";
  return <input ref={ref} className={classes} {...rest} />;
});
